export enum BreakpointsEnum {
  xSmall = 320,
  small = 400,
  sMedium = 580,
  medium = 767,
  large = 1080,
}

export const MediaQueries = {
  screen: {
    mobile: {
      maxWidth: `@media (max-width: ${BreakpointsEnum.small}px)`,
    },
    sMedium: {
      maxWidth: `@media (max-width: ${BreakpointsEnum.sMedium}px)`,
      minWidth: `@media (min-width: ${BreakpointsEnum.sMedium}px)`,
    },
    medium: {
      maxWidth: `@media (max-width: ${BreakpointsEnum.medium}px)`,
      minWidth: `@media (min-width: ${BreakpointsEnum.medium}px)`,
    },
    large: {
      maxWidth: `@media (max-width: ${BreakpointsEnum.large}px)`,
      minWidth: `@media (min-width: ${BreakpointsEnum.large}px)`,
    },
  },
};
